import type { ChangeReasonKind } from '@/Network/Types/Requests/ChangeReasonRequests'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import type { CoveragePlan } from './coverageAllocation'

/**
 * SPEC §4.1 aplicada às linhas que o lote vai mudar. A tela só sabe o ocupante de cada linha
 * (não o time dele), então "Interno→Externo" e "Externo→Externo" com o mesmo médico pedem o
 * motivo de externo; o backend ignora o que não aconteceu (S9).
 */
type ReasonOptions = { targetDoctorId: number | null; externalTeam: boolean }
type ApplicableRow = CoveragePlan['applicableRows'][number]

function rowReasons(
  target: CoveragePlan['target'],
  { status, station }: ApplicableRow,
  options: ReasonOptions
): { removal: boolean; external: boolean } {
  if (target === CoverageMode.OPEN) {
    return { removal: status !== CoverageStatus.OPEN, external: false }
  }
  if (target === CoverageMode.UNIDENTIFIED) {
    return {
      removal: status === CoverageStatus.DOCTOR,
      external: status !== CoverageStatus.UNIDENTIFIED
    }
  }
  return {
    removal: status === CoverageStatus.DOCTOR && station.doctorId !== options.targetDoctorId,
    external: options.externalTeam && status !== CoverageStatus.UNIDENTIFIED
  }
}

export function requiredReasonKinds(
  plan: CoveragePlan,
  options: ReasonOptions
): ChangeReasonKind[] {
  const reasons = plan.applicableRows.map((row) => rowReasons(plan.target, row, options))
  const removal = reasons.some((r) => r.removal)
  const external = reasons.some((r) => r.external)
  const kinds: ChangeReasonKind[] = []
  if (removal) kinds.push('removal')
  if (external) kinds.push('external')
  return kinds
}
